// This file was auto generated by resource-sync tools.

import ar_b_fe_vender_pc from './ar/b_fe_vender_pc.json';
import en_b_fe_vender_pc from './en/b_fe_vender_pc.json';
import ur_b_fe_vender_pc from './ur/b_fe_vender_pc.json';
import zh_b_fe_vender_pc from './zh/b_fe_vender_pc.json';


const resources = {
    'namespaces': 
    [{"localeInfos":[{"locale":"ar","version":28},{"locale":"en","version":32},{"locale":"ur","version":1},{"locale":"zh","version":20}],"i18nConfig":{"apiKey":"5960afab14104e319ab1a7db5057e908","projectId":43,"namespaceId":"igkekhb84x","namespaceName":"b_fe_vender_pc"}}],
    'ar': {
        b_fe_vender_pc: ar_b_fe_vender_pc
    },
    'en': {
        b_fe_vender_pc: en_b_fe_vender_pc
    },
    'ur': {
        b_fe_vender_pc: ur_b_fe_vender_pc
    },
    'zh': {
        b_fe_vender_pc: zh_b_fe_vender_pc
    }
};

export default resources;